import React, { Component } from "react";
import Helmet from "react-helmet";
import logo from "../../static/converted/logo-min.png";

class SEO extends Component {
  render() {
    const desc = "Der Bootsverleih und Guidungservice am PO",
      title = "wallerwelt.com",
      url = "https://wallerwelt.com",
      fbAppId = "";

    const schemaOrgJSONLD = [
      {
        "@context": "http://schema.org",
        "@type": "Organization",
        url: url,
        sameAs: [
          "https://www.facebook.com/Wallerwelt-by-Markus-Eule-296950883708594/",
          "https://www.facebook.com/WallerWelt2.0/"
        ],
        address: {
          "@type": "PostalAddress",
          addressLocality: "Borgoforte, Italien",
          postalCode: "IT-46030",
          streetAddress: "Via Al Ponte 1"
        },
        email: "info(at)wallerwelt.com",
        alumni: [
          {
            "@type": "Person",
            name: "Markus Eule"
          }
        ],
        member: [
          {
            "@type": "Organization"
          }
        ],
        name: "Waller-Welt (Waller-Welt.com)",
        contactPoint: [
          {
            "@type": "ContactPoint",
            telephone: "+39-345-997-3997",
            contactType: "customer service"
          }
        ]
      }
    ];
    return (
      <Helmet htmlAttributes={{ lang: "de", amp: undefined }}>
        {/* General tags */}
        <meta name="description" content={desc} />
        <meta name="image" content={logo} />

        {/* Schema.org tags */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>

        {/* OpenGraph tags */}
        <meta property="og:title" content={title} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={logo} />
        <meta
          property="fb:app_id"
          content={fbAppId.length > 0 ? fbAppId : ""}
        />
      </Helmet>
    );
  }
}

export default SEO;



// WEBPACK FOOTER //
// ./src/components/SEO/index.js